import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import Grid from "@saleor/components/Grid";
import { ProductErrorFragment } from "@saleor/fragments/types/ProductErrorFragment";
import { getFormErrors, getProductErrorMessage } from "@saleor/utils/errors";
import createNonNegativeValueChangeHandler from "@saleor/utils/handlers/nonNegativeValueChangeHandler";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface ProductVariantGetErpProps {
  sku: string;
  disabled: boolean;
  errors: ProductErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
  onGetErpData: (erpSku: string) => void;
}

const ProductVariantGetErp: React.FC<ProductVariantGetErpProps> = props => {
  const { sku, disabled, errors, onChange, onGetErpData } = props;

  const intl = useIntl();

  const formErrors = getFormErrors(["sku"], errors);
  const handleChange = createNonNegativeValueChangeHandler(onChange);

  const [erpSku, setErpSku] = React.useState<string>("");
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "SKU",
          description: "get erp sku data"
        })}
      />
      <CardContent>
        <Grid variant="uniform">
          <TextField
            disabled={disabled}
            error={!!formErrors.sku}
            fullWidth
            helperText={getProductErrorMessage(formErrors.sku, intl)}
            label={intl.formatMessage({
              defaultMessage: "SKU (Stock Keeping Unit)"
            })}
            name="sku"
            onChange={e => {
              handleChange(e);
              setErpSku(e.target.value);
            }}
            value={erpSku || sku}
          />
          <Button
            onClick={() => onGetErpData(erpSku || sku)}
            color="primary"
            variant="contained"
            data-test="get-erp-sku"
          >
            <FormattedMessage
              defaultMessage="Get Information"
              description="button"
            />
          </Button>
        </Grid>
      </CardContent>
    </Card>
  );
};
ProductVariantGetErp.displayName = "ProductVariantGetErp";
export default ProductVariantGetErp;
